import styled from 'styled-components';

// Components
import GenericChips from '../../../../components/common/GenericChip';
import TeacherCommentsModal from '../../../../components/shared/presentation-comments/TeacherCommentsModal';
import StudentSummaryAIModal from '../../../course/components/main/IA/StudentSummaryAIModal';

const StudentTaskHeader = (props) => {
    const {
        correctedSubmission,
        isRedo,
        redo,
        studentId,
        subjectId,
        teacherId,
        submissionId,
        programId,
    } = props;

    return (
        <Header>
            {/* <FirstSection>
                {resourceId && studentId && teacherId && (
                    <TeacherCommentsModal
                        buttonLabel="Chat con alumno"
                        resourceId={resourceId}
                        studentId={studentId}
                        teacherId={teacherId}
                        subjectId={subjectId}
                        learningObjectId={learningObject}
                    />
                )}
            </FirstSection> */}
            <SecondSection>
                {correctedSubmission ? (
                    <GenericChips
                        radius="10px"
                        textColor={!!isRedo || !!redo ? '#B31D15' : '#1E8065'}
                        fontSize="15px"
                        fontWeight="bold"
                        color={!!isRedo || !!redo ? '#FCE9E8' : '#EAFAF6'}
                        padding="1rem 10px"
                        title={
                            !!isRedo || !!redo
                                ? 'Rehacer actividad'
                                : 'Actividad corregida'
                        }
                    />
                ) : (
                    <GenericChips
                        radius="10px"
                        textColor="#C29F43"
                        fontSize="15px"
                        fontWeight="bold"
                        color="#F9F5EC"
                        padding="1rem 10px"
                        title="Pendiente de corrección"
                    />
                )}
                <StudentSummaryAIModal
                    workflowUrl="https://n8n.internal.aden.org/webhook/perfil_alumno"
                    additionalData={{
                        id_submission: submissionId,
                        id_user: studentId,
                        id_subject: subjectId,
                        id_program: programId,
                    }}
                    predefinedMessages={[
                        'Ver CV',
                        'Avance académico',
                        'Ver mas detalles del alumno',
                        'Tips para corregir',
                    ]}
                    sendInitialRequestOnOpen={true}
                    behaviourAction="profe_ver_perfil_alumno_por_ia"
                    behaviourDetail={JSON.stringify({
                        id_entrega: submissionId,
                        id_partner: studentId,
                        id_asignatura: subjectId,
                        id_profesor: teacherId,
                    })}
                    sharedKey={`ver-informacion-alumno-${studentId}`}
                    initialMessage="dame el contexto inicial del alumno"
                />
                {/* <CustomButton onClick={handleNavigate}>Ver perfil</CustomButton> */}
            </SecondSection>
        </Header>
    );
};

export default StudentTaskHeader;

const Header = styled.header`
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #ccc;
    @media (max-width: 1200px) {
        border-bottom: 0px;
    }
`;

const FirstSection = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding-top: 1rem;
`;

const SecondSection = styled.div`
    display: flex;
    align-items: center;
    padding: 1.5rem;
    justify-content: space-between;
    gap: 10px;
`;
